import { render, staticRenderFns } from "./BuilderComponent.vue?vue&type=template&id=2ceedf39&scoped=true"
import script from "./BuilderComponent.vue?vue&type=script&lang=js"
export * from "./BuilderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceedf39",
  null
  
)

export default component.exports